module.exports = __webpack_public_path__ + "images/home/product/mobile/features-search-8dad7352b9aae445fe57321cbbab10cb.png";